import { render, staticRenderFns } from "./reservationDetails.vue?vue&type=template&id=f3671218&scoped=true&"
import script from "./reservationDetails.vue?vue&type=script&lang=js&"
export * from "./reservationDetails.vue?vue&type=script&lang=js&"
import style0 from "./reservationDetails.vue?vue&type=style&index=0&id=f3671218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3671218",
  null
  
)

export default component.exports